export var AvatarStylePropertiesByShape = {
    circle: {
        borderRadius: '50%',
    },
    pill: {
        borderRadius: '180px',
    },
};
//# sourceMappingURL=AvatarStylePropertiesByShape.js.map